import axios from 'axios'
import qs from 'qs'
import store from '@/vuex'
import router from '@/router'

function checkPermission(data){
    if(data.result.success==444){
       alert(data.result.info)
       store.dispatch("doLogout")
       router.push("/login")
       return false;
    }
}

const config={
    baseURL: process.env.VUE_APP_API,
    timeout: 30000
  }

async function get(url,data){
    config['url']=url
    config['headers']={'bbadmintoken':store.state.user.token,'Content-Type':'application/x-www-form-urlencoded'}
    config['method']='get'

    store.commit("LOADING_START")
    const result=await axios.post(url,qs.stringify(data),config)
    store.commit("LOADING_END")
    checkPermission(result.data)
    return result.data
}

async function post(url,data){
    config['url']=url
    config['headers']={'bbadmintoken':store.state.user.token,'Content-Type':'application/x-www-form-urlencoded'}
    config['method']='post'

    store.commit("LOADING_START")
    const result=await axios.post(url,qs.stringify(data),config)
    store.commit("LOADING_END")
    checkPermission(result.data)

    return result.data
}

function download(url,data){
  const excelToken=store.state.user.token
  const params="/token/"+excelToken+"/startDate/"+data.startDate+"/endDate/"+data.endDate+"/keywords/"+data.keywords
  window.location.href=process.env.VUE_APP_API+url+params;
}

function downloadTrain(url,data){
  const excelToken=store.state.user.token
  const params="/token/"+excelToken+"/periodnum/"+data.periodnum
  window.location.href=process.env.VUE_APP_API+url+params;
}

function downloadJstTable(url,data){
  const excelToken=store.state.user.token
  const params="/token/"+excelToken+"/id/"+data.id+"/goodsinfo/"+data.goodsinfo
  window.location.href=process.env.VUE_APP_API+url+params;
}
export {get,post,download,downloadTrain,downloadJstTable} 